<div class="flex flex-col items-center byob-dashboard-wrapper max-width-lg pt-50 pb-50">

	<div *ngIf="isDataAvailable" class="flex flex-row items-center p-24 white-bg charts">
		<div class="flex flex-col">
			<div class="flex items-center mat-headline-5 fw-700 mb-0">{{ 'BYOB_DASHBOARD.SYSTEM_HEALTH' | transloco }}</div>
			<div echarts [options]="systemHealthChartOptions" class="chart-dimension "></div>
			<div class="flex justify-center mat-subtitle-2 fw-600 pt-10 cursor-pointer" (click)="openMeteringResourcesModal('systemHealth')">
				{{ 'BYOB_DASHBOARD.VIEW_ALL' | transloco }}
			</div>
		</div>
		<div class="flex flex-col">
			<div class="flex flex-row justify-between items-center">
				<div class="flex items-center mat-headline-5 fw-700 mb-0">{{ 'BYOB_DASHBOARD.SERVICE_AVAILABILITY' | transloco }}</div>
				<div class="flex justify-center justify-end mat-headline-5 fw-700 mr-50 color-coral mb-0">99.99%</div>
			</div>
			<div class="fw-500 mt-10 mb--30">Last 7 days</div>
			<div echarts [options]="serviceAvailableChartOptions" class="chart-dimension service-availability"></div>
			<div class="flex flex-row justify-between items-center mt--24">
				<div class="flex items-center ml-10">
					<img src="/assets/images/Line_95.png" >
					<div class="pl-10 pr-20">Availability</div>
					<img src="/assets/images/Line_94.png" >
					<div class="pl-10">SLA goal</div>
				</div>
			</div>
			<div class="flex justify-center mat-subtitle-2 fw-600 pt-10 cursor-pointer" (click)="openMeteringResourcesModal('systemAvailability')">{{ 'BYOB_DASHBOARD.VIEW_ALL' | transloco }}</div>
		</div>
		<div class="flex flex-col">
			<div class="flex flex-row justify-between items-center">
				<div class="flex items-center mat-headline-5 fw-700 mb-0">{{ 'BYOB_DASHBOARD.SYSTEM_SECURITY' | transloco }}</div>
				<div class="flex justify-center justify-end mat-button fw-700 cursor-pointer">
					Security Events
					<mat-icon svgIcon="chevron_right" class="icon-md ml-2"></mat-icon>
				</div>
			</div>
			<div echarts [options]="systemSecurityChartOptions" class="chart-dimension"></div>
			<div class="flex justify-center mat-subtitle-2 fw-600 pt-10 cursor-pointer" (click)="openMeteringResourcesModal('systemSecurity')">{{ 'BYOB_DASHBOARD.VIEW_ALL' | transloco }}</div>
		</div>
	</div>
	@if(hasDeploymentClassA) {
	<div class="flex flex-row">
		@if(!isMonitoringDataLoaded){
		<div class="show-skeletion w-100-percent">
			<div class="skeleton-loader">
				<ngx-skeleton-loader count="4" appearance="line"></ngx-skeleton-loader>
			</div>
		</div>
		}
		@if(isMonitoringDataLoaded && !noMonitoringData && nonProdZone) {
		<div class="health-card mt-16 w-100-percent">
			<div class="flex flex-col">
				<!-- <div>
					<div class="monitoring mb-12">{{'INSTANCE_DETAILS.MONITORING' | transloco}}</div>
					<div class="flex flex-row">
						<div class="flex flex-row mr-12">
							<div>{{'BLUEPRINT_SUMMARY.SERVICE_DEFINITION' | transloco}}:</div>
							<div class="pl-6 fw-500">{{blueprint?.name}}</div>
						</div>
						<div class="flex flex-row">
							<div>{{'BLUEPRINT_SUMMARY.ENVIRONMENT' | transloco}}:</div>
							<div class="pl-6 fw-500">{{instance?.name}}</div>
						</div>
					</div>
				</div> -->
				<div class="flex flex-row w-100-percent">
					<div class="donut-section">
						<div class="donut" [ngStyle]="nonProdZone.donutStyle">
							<div class="donut-center">
							<div class="fs-32 fw-500 font-color">{{ nonProdZone.services }}</div>
							<div class="fs-20 fw-400 font-color">{{ 'INSTANCE_DETAILS.SERVICES' | transloco }}</div>
							</div>
						</div>
					</div>
					<div class="content-section">
						<div class="status-row pl-24">
							<div class="status healthy" [class.active]="activeStatus === 'HEALTHY'" (click)="onStatusChange('HEALTHY')">
							{{ 'INSTANCE_DETAILS.HEALTHY' | transloco }}
							<span class="badge">{{ nonProdZone.healthy }}</span>
							</div>
							<div class="status impacted" [class.active]="activeStatus === 'IMPACTED'" (click)="onStatusChange('IMPACTED')">
							{{ 'INSTANCE_DETAILS.IMPACTED' | transloco }}
							<span class="badge">{{ nonProdZone.impacted }}</span>
							</div>							
							<div class="status critical" [class.active]="activeStatus === 'CRITICAL'" (click)="onStatusChange('CRITICAL')">
							{{ 'INSTANCE_DETAILS.CRITICAL' | transloco }}
							<span class="badge">{{ nonProdZone.critical }}</span>
							</div>
						</div>
						<div class="inner-panel mb-12">
							<div class="left-panel-rag flex flex-col">
							<div class="app-tag" *ngFor="let item of getFilteredItems(nonProdZone)" [class.active]="selectedItem === item" (click)="selectItem(item)">
								{{ item.product }}
							</div>
							<div class="empty p-12" *ngIf="getFilteredItems(nonProdZone).length === 0">No services</div>
							</div>
							<div class="flex flex-col ml-12 width-right">
							<div *ngIf="selectedItem?.summary" class="system-status" [ngClass]="ragToStatus(selectedItem.rag).toLowerCase()">
								{{ selectedItem.summary }}
							</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		}
	</div>
    }

	@if(!hasDeploymentClassA && !isDataAvailable) {
	<div class="flex flex-row">
		<section _ngcontent-wnm-c145="" class="justify-items-center dashboard">
			<div class="linear">
				<div class="mat-headline-1 welcome fw-500">{{ 'BYOB_DASHBOARD.WELCOME' | transloco }}</div>
				<div class="mat-body-1">{{ 'BYOB_DASHBOARD.DESCRIPTION' | transloco }}</div>
				<div class="flex flex-row mt-50">
					<!-- <button class="transparent cursor-pointer" (click)="goToReadMore()">{{ 'BYOB_DASHBOARD.READ_MORE' | transloco }}</button> -->
				</div>
				<img src="/assets/images/banner-border.png" class="border">
			</div>
		</section>
	</div>
	}
	<div class="mt-24">
		<!-- <mat-divider></mat-divider> -->
	</div>
	<div class="flex flex-row">
		<app-byob-my-services class="w-100-percent"></app-byob-my-services>
	</div>
</div>
<div class="max-width-lg hidden">
	<div class="w-100-percent pt-50">
		<app-learn-saas></app-learn-saas>
	</div>
</div>
